import React from 'react';
import FormLabel from './FormLabel';
import { Control, Controller } from 'react-hook-form';
import ErrorMessage from './ErrorMessage';

type PasswordInputProps = {
	name: string;
	label?: string;
	maxLength?: number;
	placeholder?: string;
	control: Control<any>;
	errorMessage: string | undefined;
};

export default function PasswordInput({
	name,
	label,
	maxLength,
	placeholder,
	control,
	errorMessage,
}: PasswordInputProps) {
	return (
		<div className="relative">
			{label && <FormLabel labelFor={name} labelName={label} />}
			<Controller
				control={control}
				name={name}
				render={({ field: { ref, ...field } }) => (
					<div className="mt-2 rounded-md">
						<input
							type="password"
							id={name}
							maxLength={maxLength || 255}
							placeholder={placeholder || ''}
							className={`${errorMessage ? 'app-input-error' : 'app-input-default'}`}
							aria-invalid={!!errorMessage}
							aria-describedby={`${name}-error`}
							{...field}
							onInput={(e: React.FormEvent<HTMLInputElement>) => {
								e.currentTarget.value = e.currentTarget.value.trim();
							}}
						/>
					</div>
				)}
			/>
			{!!errorMessage && <ErrorMessage inputId={name} errorMessage={errorMessage} />}
		</div>
	);
}
